module.exports = [{
      plugin: require('/Users/gauthier/Sites/b2a-mails/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
